import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

type Props = {};

export default function ServiceRentalRedirect(props: Props) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.startsWith("/service/rental")) {
      const state = { type: location.pathname.split("-")[1] };
      navigate("/service/rental", { state, replace: true });
    }
  }, []);

  return <div>ServiceRentalRedirect</div>;
}
